module.exports = __webpack_public_path__ + "147aedce3ed06d11baeb8bc8de8d11bf.png";